import Vue from 'vue'
import {AclCreate, AclInstaller, AclRule} from 'vue-acl'
import router from '@/router'
import store from '@/store/store'

Vue.use(AclInstaller)

let initialRole = 'visitor'

const userInfo = JSON.parse(localStorage.getItem('userInfo'))
if (userInfo && userInfo.role) initialRole = userInfo.role

export default new AclCreate({
  initial: initialRole || 'visitor',
  notfound: {
    path: '/not-authorized',
    forwardQueryParams: true
  },
  router,
  acceptLocalRules: true,
  globalRules: {
    visitor: new AclRule('visitor')
      .or('user')
      .or('employee')
      .or('proctor')
      .or('sys_admin')
      .or('admin')
      .generate(),
    user: new AclRule('user')
      .or('employee')
      .or('proctor')
      .or('sys_admin')
      .or('admin')
      .generate(),
    employee: new AclRule('employee')
      .or('proctor')
      .or('sys_admin')
      .or('admin')
      .generate(),
    proctor: new AclRule('proctor')
      .or('sys_admin')
      .or('admin')
      .generate(),
    sys_admin: new AclRule('sys_admin')
      .generate(),
    admin: new AclRule('admin')
      .or('sys_admin')
      .generate()
  },
  middleware: async acl => {
    await store.dispatch('auth/refreshUserObject', acl)
  }
})
